import { Link } from 'react-router-dom'

import styled from 'styled-components'

export const Page = styled.div`
  width: 100%;
  margin-top: 70px;
  background: #fff;
  color: #171717;

  @media (max-width: 800px) {
    margin-top: 50px;
  }
`

export const TopLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 48px;
  padding: 10px 20px;
  font-size: 22px;
  color: #454545;
  background: #fff;
`

export const Cover = styled.div`
  position: relative;
  width: 100%;
  height: 320px;
  overflow: hidden;
  background: #f3f3f3;
`

export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const SearchButton = styled.button`
  position: absolute;
  top: 18px;
  right: 22px;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 13px;
  border: 1px solid #e2e2e2;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.96);
  color: #666;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);

  img {
    width: 17px;
    height: 17px;
  }
`

export const IdentityRow = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 18px;
  width: min(1540px, calc(100% - 48px));
  min-height: 138px;
  margin: -68px auto 0;
  padding: 0 12px 0 194px;

  @media (max-width: 980px) {
    flex-wrap: wrap;
    padding: 82px 10px 18px;
    margin-top: -76px;
  }

  @media (max-width: 640px) {
    width: calc(100% - 24px);
    gap: 12px;
    padding: 82px 0 18px;
  }
`

export const Avatar = styled.img`
  position: absolute;
  left: 8px;
  top: -18px;
  width: 164px;
  height: 164px;
  border: 6px solid #fff;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.16);
  background: #fff;

  @media (max-width: 980px) {
    width: 132px;
    height: 132px;
    top: -52px;
    left: 16px;
  }
`

export const Identity = styled.div`
  min-width: 250px;
  flex: 1;
  max-width: 560px;
  padding: 14px 18px 15px;
  border: 1px solid rgba(232, 232, 232, 0.95);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.09);

  @media (max-width: 640px) {
    width: 100%;
    min-width: 0;
  }
`

export const Eyebrow = styled.div`
  display: none;
`

export const NameLine = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
`

export const Name = styled.div`
  font-size: 28px;
  line-height: 1.1;
  font-weight: 700;
  color: #151515;
`

export const VerifiedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 25px;
  padding: 0 9px;
  border: 1px solid rgba(229, 9, 9, 0.18);
  border-radius: 999px;
  background: #fff4f4;
  color: #df0b0b;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;

  svg {
    font-size: 12px;
  }

  @media (max-width: 640px) {
    min-height: 23px;
    padding: 0 8px;
    font-size: 10px;
  }
`

export const Subtitle = styled.div`
  margin-top: 7px;
  font-size: 13px;
  line-height: 1.4;
  color: #707070;
`

export const SocialActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const FollowButton = styled.button`
  min-width: 170px;
  height: 46px;
  padding: 0 24px;
  border: 0;
  border-radius: 10px;
  background: #e50909;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(229, 9, 9, 0.22);
`

export const Stats = styled.div`
  display: flex;
  align-items: stretch;
  margin-left: auto;
  padding: 7px 8px;
  border: 1px solid rgba(232, 232, 232, 0.95);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.09);

  @media (max-width: 640px) {
    width: 100%;
    min-width: 0;
    margin-left: 0;
    padding: 6px 4px;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    overflow: hidden;
  }
`

export const Stat = styled.div`
  min-width: 88px;
  padding: 8px 13px;
  text-align: center;
  border-left: 1px solid #e8e8e8;

  &:first-child {
    border-left: 0;
  }

  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 20px;
    line-height: 1;
    color: #181818;
  }

  span {
    font-size: 11px;
    color: #707070;
  }

  @media (max-width: 640px) {
    min-width: 0;
    padding: 8px 3px;

    strong {
      margin-bottom: 5px;
      font-size: 18px;
    }

    span {
      display: block;
      max-width: 100%;
      overflow: hidden;
      font-size: 9px;
      line-height: 1.2;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

export const InspirationStat = styled(Stat)`
  border-radius: 9px;
  background: linear-gradient(180deg, #fffaf0 0%, #fff5dc 100%);
  box-shadow: inset 0 0 0 1px rgba(196, 153, 56, 0.14);

  strong {
    color: #b8891f;
    font-size: 22px;
    font-weight: 800;
  }

  span {
    color: #9a7527;
    font-weight: 700;
  }

  @media (max-width: 640px) {
    strong {
      font-size: 19px;
    }
  }
`

export const InfoRibbon = styled.div`
  display: grid;
  grid-template-columns: 1.35fr 0.65fr 1fr;
  width: min(1540px, calc(100% - 48px));
  margin: 10px auto 30px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 14px;
  box-shadow: 0 9px 30px rgba(0, 0, 0, 0.06);

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const InfoBlock = styled.div`
  min-height: 96px;
  display: block;
  padding: 16px 22px;
  border-right: 1px solid #ededed;

  @media (max-width: 900px) {
    border-right: 0;
    border-bottom: 1px solid #ededed;
  }
`

export const RankBlock = styled(InfoBlock)`
  text-align: left;
`

export const InfoIcon = styled.div`
  display: none;
`

export const InfoContent = styled.div`
  min-width: 0;
  width: 100%;
`

export const InfoTitle = styled.div`
  min-height: 20px;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  color: #222;
`

export const InfoText = styled.div`
  max-width: 100%;
  font-size: 13px;
  line-height: 1.45;
  color: #747474;
`

export const AboutText = styled.button<{ $expanded: boolean }>`
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  font: inherit;
  font-size: 13px;
  line-height: 1.45;
  color: #747474;
  cursor: pointer;

  ${({ $expanded }) =>
    !$expanded &&
    `
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `}
`

export const Interests = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
`

export const Interest = styled.div`
  width: 31px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #ececec;
  border-radius: 50%;
  background: #fafafa;
  color: #2f3437;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 1.8;
  }
`

export const Section = styled.section`
  width: min(1540px, calc(100% - 48px));
  margin: 0 auto 34px;
`

export const InspiredSection = styled(Section)`
  padding: 22px;
  border: 1px solid #f0dddd;
  border-radius: 18px;
  background: #fffafa;
`

export const SectionDescription = styled.p`
  margin: 5px 0 0;
  color: #777;
  font-size: 12px;
  line-height: 1.4;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  margin-bottom: 16px;

  h2 {
    margin: 0;
    font-size: 29px;
    line-height: 1.2;
    color: #171717;
  }
`

export const CreateButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 17px;
  border-radius: 8px;
  background: #e50909;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
  width: 100%;

  @media (max-width: 1320px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: 1040px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`

export const CardShell = styled.div`
  position: relative;
  min-width: 0;
  width: 100%;
`

export const Card = styled(Link)`
  display: block;
  width: 100%;
  overflow: hidden;
  border: 1px solid #e1e1e1;
  border-radius: 12px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.06);
  transition:
    transform 160ms ease,
    box-shadow 160ms ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 9px 22px rgba(0, 0, 0, 0.09);
  }
`

export const CardActions = styled.div`
  position: absolute;
  z-index: 3;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 5px;
`

export const EditCardButton = styled(Link)`
  min-height: 27px;
  padding: 0 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #333;
  font-size: 10px;
  font-weight: 600;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.1);
`

export const DeleteCardButton = styled.button`
  min-height: 27px;
  padding: 0 9px;
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #c60000;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.1);
`

export const CardImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 6.4;
  object-fit: cover;
  display: block;
`

export const CardBody = styled.div`
  padding: 10px 12px 11px;
`

export const CardTitle = styled.div`
  display: -webkit-box;
  min-height: 34px;
  margin-bottom: 6px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 12px;
  line-height: 1.3;
  font-weight: 700;
  color: #171717;
`

export const RatingRow = styled.div`
  min-height: 18px;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 6px;
  font-size: 10px;
  color: #757575;

  strong {
    font-size: 10px;
    color: #4f4f4f;
  }
`

export const RatingStar = styled.span`
  color: #f5b301;
  font-size: 13px;
  line-height: 1;
`

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 6px;
  border-top: 1px solid #f0f0f0;
  font-size: 9px;
  color: #686868;
`

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`

export const Empty = styled.div`
  padding: 36px;
  text-align: center;
  color: #888;
`

export const InvitationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const InvitationCard = styled.div`
  display: grid;
  grid-template-columns: 76px 1fr auto;
  align-items: center;
  gap: 14px;
  min-height: 82px;
  padding: 10px 12px;
  border: 1px solid #ece8e5;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.04);

  > img {
    width: 76px;
    height: 58px;
    border-radius: 10px;
    object-fit: cover;
  }

  > div {
    min-width: 0;
  }

  strong {
    display: block;
    color: #2f2f2f;
    font-size: 14px;
  }

  span {
    display: block;
    margin-top: 3px;
    color: #888;
    font-size: 11px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 64px 1fr;

    > img {
      width: 64px;
      height: 52px;
    }
  }
`

export const InvitationActions = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;

  button {
    min-height: 34px;
    padding: 0 13px;
    border: 1px solid #dddddd;
    border-radius: 999px;
    background: #fff;
    color: #666;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
  }

  button.accept {
    border-color: #e00000;
    background: #e00000;
    color: #fff;
  }

  @media (max-width: 640px) {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
`

export const CollaborativeBadge = styled.span`
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  min-height: 25px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #d00000;
  font-size: 9px;
  font-weight: 800;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
`

export const InspiredBadge = styled(Link)`
  position: absolute;
  z-index: 3;
  top: 8px;
  left: 8px;
  min-height: 25px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  color: #c60000;
  font-size: 9px;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);

  &:hover {
    text-decoration: underline;
  }
`

export const DeleteModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(19, 24, 30, 0.56);
  backdrop-filter: blur(3px);

  @media (max-width: 640px) {
    align-items: flex-end;
    padding: 0;
  }
`

export const DeleteModal = styled.div`
  width: min(460px, 100%);
  padding: 22px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.25);

  @media (max-width: 640px) {
    width: 100%;
    padding: 20px 18px 18px;
    border-radius: 24px 24px 0 0;
  }
`

export const DeleteModalIcon = styled.div`
  width: 42px;
  height: 42px;
  margin-bottom: 14px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #fff1f1;
  color: #d40000;
  font-size: 24px;
  font-weight: 900;
`

export const DeleteModalContent = styled.div`
  h3 {
    margin: 0;
    color: #20252d;
    font-size: 21px;
  }

  p {
    margin: 10px 0 0;
    color: #69717d;
    font-size: 13px;
    line-height: 1.55;
  }
`

export const DeleteModalActions = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  button {
    min-height: 42px;
    padding: 0 16px;
    border: 1px solid #dfe3e8;
    border-radius: 10px;
    background: #fff;
    color: #4e5662;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
  }

  button.danger {
    border-color: #e50909;
    background: #e50909;
    color: #fff;
  }

  button:disabled {
    opacity: 0.65;
    cursor: wait;
  }

  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: 1fr 1fr;

    button {
      width: 100%;
      min-height: 46px;
    }
  }
`
